import React , {useState}from 'react';
import {Cookies}  from '../js/localStorageCode';
import './FilteredItems.css';
import {DataSummaryModal} from './Modals';
import { TransactionDetails } from '../types/StockhornTypes';

interface TableRow {
  id: string;
  name: string;
  value: number;
}

// interface ComputedValues {
//   total: number;
//   average: number;
// }

// interface FinalData {
//   rows: TableRow[];
//   amount: string;
//   [key: string]: any; // For any additional metadata
// }

interface FinalData {
  rows: TransactionDetails[];
  amount: string;
  [key: string]: any; // For any additional metadata
}

interface ComputedValues {
  expires: number;
  value: FinalData;
}

const environment = document.location.hostname.match(/meekmeek/) ? 'PROD' : document.location.hostname.match(/vercel/) ? 'PREVIEW': 'DEV';
const FilteredItems: React.FC = () => {
  const cookies = new Cookies();
  document.title = environment+':Filtered Items';
  const allData = cookies.getAll();

  const keyList = Object.keys(allData).reverse();
  const [selectedData, setSelectedData] = useState<TableRow[] | ComputedValues | null>(null);
  const [selectedKey, setSelectedKey] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModalLoading, setIsModalLoading] = useState<boolean>(false);

  const handleSelect = (key: string) => {
    setSelectedKey(key);
    setIsModalLoading(true);
    // Simulate loading delay (replace with actual async logic if needed)
    //setTimeout(() => {
      setSelectedData(allData[key]);
      setIsModalLoading(false);
      setIsModalOpen(true); // Open modal on selection
    //}, 500);
  };

  return (
    <div className='home'>
      {!isModalOpen && (
        <>
          <h1>Filtered Items Page</h1>
          <ul className="clickable-list">
              {keyList.map((key) => !key.match(/^TRACK|^Balance|^Business/) && (
                <li
                  key={key}
                  className={`list-item ${!key.match(/^EXPENSE_CATEGORY/) ? 'original' : 'expense'}`}
                  onClick={() => handleSelect(key)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handleSelect(key)}
                >
                  {key}
                </li>
              ))}
            </ul>
          </>
        )}
        {isModalOpen && (
          <DataSummaryModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            data={selectedData}
            selectedKey={selectedKey}
            isLoading={isModalLoading}
          />
        )}
    </div>
  );
};

export default FilteredItems;